var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/editor/mode_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.71 6.13006C21.1 6.52006 21.1 7.15006 20.71 7.54006L18.88 9.37006L15.13 5.62006L16.96 3.79006C17.35 3.40006 17.98 3.40006 18.37 3.79006L20.71 6.13006ZM3 21.5001V17.7501L14.06 6.69006L17.81 10.4401L6.75 21.5001H3Z",
    fill: "#FB263B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.e337c974a02356b7bce9332739b5946c.svg";
export { ForwardRef as ReactComponent };